import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE
// boxiaotu主后端API
const BOXIAOTU_API = 'https://api.boxiaotu.cn/api'

// 推广员等级配置（教育产品佣金率 / AI广场统一30%/40%/50%）
const PROMO_LEVELS = {
  personal: {
    name: '个人推广员',
    color: '#13c2c2',
    commission: '30%',
    canRecruit: false,
    description: '免费注册'
  },
  certified: {
    name: '保证金推广员', 
    color: '#722ed1',
    commission: '40%',
    canRecruit: true,
    description: '¥1,000保证金（可退）'
  },
  agency: {
    name: '认证推广员',
    color: '#fa8c16',
    commission: '50%',
    canRecruit: true,
    description: '¥5,000年费（不退）'
  }
}

// 升级配置
const UPGRADE_TYPES = {
  certified: {
    name: '保证金推广员',
    color: '#722ed1',
    fee: 1000,
    description: '保证金（可退）',
    features: ['佣金40%', '可招募下线', '管理奖20%']
  },
  agency: {
    name: '认证推广员',
    color: '#fa8c16',
    fee: 5000,
    description: '年费（不退）',
    features: ['佣金50%', '可招募下线', '管理奖20%']
  }
}

export default function PartnerCenter() {
  const [phone, setPhone] = useState('')
  const [password, setPassword] = useState('')
  const [localStoragePartner, setLocalStoragePartner] = useState(null)
  // 检查localStorage中的登录状态，如果无效则清除
  useEffect(() => {
    const savedUser = localStorage.getItem('cms_user')
    const savedRole = localStorage.getItem('cms_role')
    const savedId = localStorage.getItem('cms_user_id')
    
    // 如果有登录状态但没有用户ID，清除它
    if (savedUser && !savedId) {
      localStorage.removeItem('cms_user')
      localStorage.removeItem('cms_role')
      localStorage.removeItem('cms_token')
      localStorage.removeItem('cms_user_id')
      return
    }
    
    if (savedUser && savedRole === 'partner') {
      try {
        const user = JSON.parse(savedUser)
        setLocalStoragePartner(user)
        setPartner(user)
      } catch (e) {
        // 解析失败，清除登录状态
        localStorage.removeItem('cms_user')
        localStorage.removeItem('cms_role')
        localStorage.removeItem('cms_token')
        localStorage.removeItem('cms_user_id')
      }
    }
  }, [])

  // 退出登录
  const handleLogout = () => {
    localStorage.removeItem('partner_token')
    localStorage.removeItem('partner_user')
    localStorage.removeItem('partner_id')
    localStorage.removeItem('cms_token')
    localStorage.removeItem('cms_user')
    localStorage.removeItem('cms_role')
    localStorage.removeItem('cms_user_id')
    setPartner(null)
    setPhone('')
    setPassword('')
  }

  const [partner, setPartner] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [tab, setTab] = useState('overview')
  const [showUpgrade, setShowUpgrade] = useState(false)
  const [upgradeType, setUpgradeType] = useState('certified')
  const [upgradeLoading, setUpgradeLoading] = useState(false)
  const [showWithdraw, setShowWithdraw] = useState(false)
  const [withdrawAmount, setWithdrawAmount] = useState('')
  const [withdrawLoading, setWithdrawLoading] = useState(false)

  // 获取当前等级配置
  const getLevelConfig = (promoType) => {
    return PROMO_LEVELS[promoType] || PROMO_LEVELS.personal
  }

  const levelConfig = partner ? getLevelConfig(partner.promo_type) : null

  // 登录（支持密码或phone-only）
  const handleLogin = async () => {
    if (!phone.trim()) {
      setError('请输入手机号')
      return
    }
    setLoading(true)
    setError('')
    
    try {
      // 构建登录参数：有密码就传密码，没有就只传手机号
      const loginBody = { phone: phone.trim() }
      if (password.trim()) {
        loginBody.password = password.trim()
      }
      
      const res = await fetch(`${BOXIAOTU_API}/partners/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(loginBody)
      })
      const data = await res.json()
      
      if (data.success) {
        const userData = data.partner || data.data
        // 同时存 partner_token 和 cms_token（兼容两套体系）
        const token = data.token || 'partner_token_' + phone.trim()
        localStorage.setItem('partner_token', token)
        localStorage.setItem('partner_user', JSON.stringify(userData))
        localStorage.setItem('partner_id', userData.id)
        localStorage.setItem('cms_token', token)
        localStorage.setItem('cms_user', JSON.stringify(userData))
        localStorage.setItem('cms_role', 'partner')
        localStorage.setItem('cms_user_id', userData.id)
        
        // 从 /api/partners/:id 获取包含佣金记录的完整数据
        try {
          const detailRes = await fetch(`${BOXIAOTU_API}/partners/${userData.id}`)
          const detailData = await detailRes.json()
          if (detailData.success && detailData.data) {
            const fullData = { ...userData, ...detailData.data }
            setPartner(fullData)
            localStorage.setItem('cms_user', JSON.stringify(fullData))
          } else {
            setPartner(userData)
          }
        } catch {
          setPartner(userData)
        }
      } else {
        setError(data.error || '登录失败，请确认手机号已注册为推广员')
      }
    } catch (e) {
      setError('网络错误，请检查网络后重试')
    }
    setLoading(false)
  }

  // 格式化金额
  const formatMoney = (amount) => {
    return (amount || 0).toFixed(2)
  }

  // 登录页面
  if (!partner) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '60px 20px 40px'
      }}>
        {/* 返回按钮 */}
        <div style={{ maxWidth: 400, margin: '0 auto 20px' }}>
          <button 
            onClick={() => window.history.back()}
            style={{
              background: 'rgba(255,255,255,0.2)',
              border: 'none',
              borderRadius: 8,
              padding: '10px 20px',
              color: '#fff',
              fontSize: 14,
              cursor: 'pointer'
            }}
          >
            ← 返回
          </button>
        </div>
        
        <div style={{ maxWidth: 400, margin: '0 auto', background: '#fff', borderRadius: 16, padding: 32 }}>
          <div style={{ textAlign: 'center', marginBottom: 32 }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>🎋</div>
            <h1 style={{ fontSize: 24, color: '#333', marginBottom: 8 }}>推广员中心</h1>
            <p style={{ color: '#666', fontSize: 14 }}>登录查看您的推广数据</p>
          </div>
          
          <div style={{ marginBottom: 20 }}>
            <label style={{ display: 'block', marginBottom: 8, color: '#333', fontSize: 14, fontWeight: 500 }}>
              手机号
            </label>
            <input
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="请输入注册手机号"
              style={{ 
                width: '100%', 
                padding: '12px 16px', 
                border: '1px solid #ddd',
                borderRadius: 8,
                fontSize: 16,
                outline: 'none'
              }}
            />
          </div>

          <div style={{ marginBottom: 20 }}>
            <label style={{ display: 'block', marginBottom: 8, color: '#333', fontSize: 14, fontWeight: 500 }}>
              密码（选填）
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="已注册推广员可不填密码登录"
              style={{ 
                width: '100%', 
                padding: '12px 16px', 
                border: '1px solid #ddd',
                borderRadius: 8,
                fontSize: 16,
                outline: 'none'
              }}
            />
          </div>
          
          {error && (
            <div style={{ color: '#ff4d4f', fontSize: 14, marginBottom: 16, textAlign: 'center' }}>
              {error}
            </div>
          )}
          
          <button
            onClick={handleLogin}
            disabled={loading}
            style={{
              width: '100%',
              padding: '14px',
              background: loading ? '#ccc' : '#667eea',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              fontSize: 16,
              fontWeight: 500,
              cursor: loading ? 'not-allowed' : 'pointer'
            }}
          >
            {loading ? '登录中...' : '登录'}
          </button>
          
          <div style={{ marginTop: 24, textAlign: 'center' }}>
            <a 
              href={`${window.location.origin}/promoter-apply.html`}
              style={{ color: '#667eea', fontSize: 14 }}
            >
              还没有推广ID？立即申请 →
            </a>
          </div>
        </div>
      </div>
    )
  }

  // 推广员中心主页
  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      {/* 头部 */}
      <div style={{ 
        background: `linear-gradient(135deg, ${levelConfig.color} 0%, ${levelConfig.color}99 100%)`,
        padding: '40px 20px 60px',
        color: '#fff'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 }}>
          <div>
            <h1 style={{ fontSize: 20, margin: 0 }}>🎋 {partner.name}</h1>
            <p style={{ fontSize: 12, opacity: 0.9, margin: '4px 0 0' }}>{levelConfig.name}</p>
          </div>
          <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
            <button 
              onClick={handleLogout}
              style={{
                background: 'rgba(255,255,255,0.2)',
                color: '#fff',
                border: '1px solid rgba(255,255,255,0.5)',
                borderRadius: 6,
                padding: '6px 16px',
                fontSize: 13,
                cursor: 'pointer'
              }}
            >
              退出
            </button>
            <div style={{ 
              background: 'rgba(255,255,255,0.2)',
              padding: '6px 12px',
              borderRadius: 20,
              fontSize: 12
            }}>
              ID: {partner.id}
            </div>
          </div>
        </div>
        
        {/* 余额卡片 */}
        <div style={{ 
          background: '#fff',
          borderRadius: 12,
          padding: 20,
          color: '#333'
        }}>
          <div style={{ fontSize: 12, color: '#666', marginBottom: 8 }}>可提现余额（元）</div>
          <div style={{ fontSize: 32, fontWeight: 700, color: '#52c41a' }}>¥{formatMoney(partner.balance)}</div>
          <div style={{ fontSize: 12, color: '#999', marginTop: 8 }}>
            累计佣金: ¥{formatMoney(partner.total_commission)}
            {levelConfig.canRecruit && partner.downline_count > 0 && ` | 下线: ${partner.downline_count}人`}
          </div>
        </div>
      </div>
      
      {/* Tab切换 */}
      <div style={{ 
        display: 'flex',
        background: '#fff',
        borderBottom: '1px solid #eee',
        marginTop: -20
      }}>
        {['overview', 'commission', 'upgrade'].map((t) => (
          <button
            key={t}
            onClick={() => setTab(t)}
            style={{
              flex: 1,
              padding: '14px',
              background: 'none',
              border: 'none',
              borderBottom: tab === t ? `2px solid ${levelConfig.color}` : '2px solid transparent',
              color: tab === t ? levelConfig.color : '#666',
              fontSize: 14,
              fontWeight: tab === t ? 600 : 400,
              cursor: 'pointer'
            }}
          >
            {t === 'overview' ? '📊 数据概览' : t === 'commission' ? '💰 我的佣金' : '🌟 升级权益'}
          </button>
        ))}
        {/* 只有认证和机构才有下线管理 */}
        {levelConfig.canRecruit && (
          <button
            onClick={() => setTab('downlines')}
            style={{
              flex: 1,
              padding: '14px',
              background: 'none',
              border: 'none',
              borderBottom: tab === 'downlines' ? `2px solid ${levelConfig.color}` : '2px solid transparent',
              color: tab === 'downlines' ? levelConfig.color : '#666',
              fontSize: 14,
              fontWeight: tab === 'downlines' ? 600 : 400,
              cursor: 'pointer'
            }}
          >
            👥 下线管理
          </button>
        )}
      </div>
      
      {/* 内容区域 */}
      <div style={{ padding: 16 }}>
        {/* 数据概览 */}
        {tab === 'overview' && (
          <div>
            {/* 统计卡片 */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 16 }}>
              <div style={{ background: '#fff', borderRadius: 12, padding: 16, textAlign: 'center' }}>
                <div style={{ fontSize: 24, fontWeight: 700, color: levelConfig.color }}>{levelConfig.commission}</div>
                <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>佣金比例</div>
              </div>
              {levelConfig.canRecruit ? (
                <div style={{ background: '#fff', borderRadius: 12, padding: 16, textAlign: 'center' }}>
                  <div style={{ fontSize: 24, fontWeight: 700, color: '#1890ff' }}>{partner.downline_count || 0}</div>
                  <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>下线人数</div>
                </div>
              ) : (
                <div style={{ background: '#fff', borderRadius: 12, padding: 16, textAlign: 'center' }}>
                  <div style={{ fontSize: 18, fontWeight: 700, color: '#fa8c16' }}>❌</div>
                  <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>暂不可招募</div>
                </div>
              )}
              <div style={{ background: '#fff', borderRadius: 12, padding: 16, textAlign: 'center' }}>
                <div style={{ fontSize: 24, fontWeight: 700, color: '#52c41a' }}>¥{formatMoney(partner.total_commission)}</div>
                <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>累计佣金</div>
              </div>
              <div style={{ background: '#fff', borderRadius: 12, padding: 16, textAlign: 'center' }}>
                <div style={{ fontSize: 24, fontWeight: 700, color: '#722ed1' }}>{levelConfig.canRecruit ? '20%' : '0%'}</div>
                <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>管理奖比例</div>
              </div>
            </div>
            
            {/* 等级说明 */}
            <div style={{ background: '#fff', borderRadius: 12, padding: 16, marginBottom: 16 }}>
              <h3 style={{ fontSize: 14, margin: '0 0 12px', color: levelConfig.color }}>📋 {levelConfig.name}权益</h3>
              <div style={{ fontSize: 13, color: '#666', lineHeight: 1.8 }}>
                <div>• 佣金比例：{levelConfig.commission}</div>
                <div>• {levelConfig.canRecruit ? '✓ 可招募下线' : '✗ 暂不支持招募下线'}</div>
                <div>• 注册费用：{levelConfig.description}</div>
              </div>
            </div>
            
            {/* 我的推广链接 */}
            <div style={{ background: '#fff', borderRadius: 12, padding: 16 }}>
              <h3 style={{ fontSize: 14, margin: '0 0 12px' }}>🔗 我的推广链接</h3>
              <div style={{ background: '#f5f5f5', padding: '12px 16px', borderRadius: 8, fontSize: 13, wordBreak: 'break-all', color: '#666', marginBottom: 12 }}>
                {window.location.origin}/promoter-apply.html?ref={partner.id}
              </div>
              <button 
                onClick={() => {
                  navigator.clipboard.writeText(`${window.location.origin}/promoter-apply.html?ref=${partner.id}`)
                  alert('推广链接已复制！')
                }}
                style={{ width: '100%', padding: '12px', background: levelConfig.color, color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, cursor: 'pointer' }}
              >
                复制推广链接
              </button>
            </div>
          </div>
        )}
        
        {/* 我的佣金 */}
        {tab === 'commission' && (
          <div>
            <div style={{ background: '#fff', borderRadius: 12, padding: 16, marginBottom: 16 }}>
              <h3 style={{ fontSize: 14, margin: '0 0 16px' }}>💰 佣金明细</h3>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div style={{ padding: 16, background: '#f6ffed', borderRadius: 8, textAlign: 'center' }}>
                  <div style={{ fontSize: 20, fontWeight: 700, color: '#52c41a' }}>¥{formatMoney(partner.balance)}</div>
                  <div style={{ fontSize: 12, color: '#666' }}>可提现</div>
                </div>
                <div style={{ padding: 16, background: '#e6f7ff', borderRadius: 8, textAlign: 'center' }}>
                  <div style={{ fontSize: 20, fontWeight: 700, color: '#1890ff' }}>¥{formatMoney(partner.total_commission)}</div>
                  <div style={{ fontSize: 12, color: '#666' }}>累计佣金</div>
                </div>
              </div>
            </div>
            
            {/* 提现申请 */}
            <div style={{ background: '#fff', borderRadius: 12, padding: 16 }}>
              <h3 style={{ fontSize: 14, margin: '0 0 12px' }}>💸 申请提现</h3>
              <input 
                type="number" 
                value={withdrawAmount}
                onChange={(e) => setWithdrawAmount(e.target.value)}
                placeholder="请输入提现金额"
                style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: 8, fontSize: 16, boxSizing: 'border-box', marginBottom: 12 }}
              />
              <button 
                onClick={async () => {
                  if (!withdrawAmount || parseFloat(withdrawAmount) <= 0) {
                    alert('请输入正确的金额')
                    return
                  }
                  if (parseFloat(withdrawAmount) > (partner.balance || 0)) {
                    alert('提现金额不能超过可提现余额')
                    return
                  }
                  setWithdrawLoading(true)
                  try {
                    const res = await fetch(`${BOXIAOTU_API}/partners/withdraw`, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ phone: partner.phone, amount: parseFloat(withdrawAmount) })
                    })
                    const data = await res.json()
                    if (data.success) {
                      alert('提现申请已提交！')
                      setWithdrawAmount('')
                    } else {
                      alert(data.error || '申请失败')
                    }
                  } catch {
                    alert('网络错误')
                  }
                  setWithdrawLoading(false)
                }}
                disabled={withdrawLoading || partner.balance <= 0}
                style={{ width: '100%', padding: '12px', background: partner.balance > 0 ? '#52c41a' : '#ccc', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, cursor: partner.balance > 0 ? 'pointer' : 'not-allowed' }}
              >
                {withdrawLoading ? '提交中...' : '立即提现'}
              </button>
              <div style={{ fontSize: 11, color: '#999', marginTop: 8, textAlign: 'center' }}>
                提现申请提交后，预计1-3个工作日到账
              </div>
            </div>
          </div>
        )}
        
        {/* 升级权益 */}
        {tab === 'upgrade' && (
          <div>
            {partner.promo_type === 'agency' ? (
              <div style={{ background: '#fff', borderRadius: 12, padding: 24, textAlign: 'center' }}>
                <div style={{ fontSize: 48, marginBottom: 16 }}>🎉</div>
                <div style={{ fontSize: 18, fontWeight: 600, color: '#52c41a', marginBottom: 8 }}>您已是最高等级</div>
                <div style={{ fontSize: 14, color: '#666' }}>认证推广员，享受全部权益</div>
              </div>
            ) : (
              <div>
                <div style={{ background: '#fff', borderRadius: 12, padding: 16, marginBottom: 16 }}>
                  <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>当前级别</div>
                  <div style={{ fontSize: 18, fontWeight: 600, color: levelConfig.color }}>{levelConfig.name}</div>
                  <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>佣金比例 {levelConfig.commission}</div>
                </div>
                
                {partner.promo_type === 'personal' && (
                  <div style={{ background: '#fff', borderRadius: 12, padding: 16, marginBottom: 16, border: `2px solid ${UPGRADE_TYPES.certified.color}` }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                      <div>
                        <div style={{ fontSize: 16, fontWeight: 600, color: UPGRADE_TYPES.certified.color }}>升级到保证金推广员</div>
                        <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>{UPGRADE_TYPES.certified.description}</div>
                      </div>
                      <button 
                        onClick={() => { setUpgradeType('certified'); setShowUpgrade(true) }}
                        style={{ padding: '8px 16px', background: UPGRADE_TYPES.certified.color, color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13 }}
                      >
                        立即升级
                      </button>
                    </div>
                    <div style={{ fontSize: 12, color: '#666' }}>
                      {UPGRADE_TYPES.certified.features.map((f, i) => (
                        <div key={i}>✓ {f}</div>
                      ))}
                    </div>
                  </div>
                )}
                
                <div style={{ background: '#fff', borderRadius: 12, padding: 16, border: `2px solid ${UPGRADE_TYPES.agency.color}` }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                    <div>
                      <div style={{ fontSize: 16, fontWeight: 600, color: UPGRADE_TYPES.agency.color }}>升级到认证推广员</div>
                      <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>{UPGRADE_TYPES.agency.description}</div>
                    </div>
                    <button 
                      onClick={() => { setUpgradeType('agency'); setShowUpgrade(true) }}
                      style={{ padding: '8px 16px', background: UPGRADE_TYPES.agency.color, color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13 }}
                    >
                      立即升级
                    </button>
                  </div>
                  <div style={{ fontSize: 12, color: '#666' }}>
                    {UPGRADE_TYPES.agency.features.map((f, i) => (
                      <div key={i}>✓ {f}</div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        
        {/* 下线管理 - 仅认证和机构可见 */}
        {tab === 'downlines' && levelConfig.canRecruit && (
          <div style={{ background: '#fff', borderRadius: 12, padding: 16 }}>
            <h3 style={{ fontSize: 14, margin: '0 0 16px' }}>👥 我的下线</h3>
            {partner.downlines && partner.downlines.length > 0 ? (
              partner.downlines.map((d, i) => (
                <div key={i} style={{ padding: '12px 0', borderBottom: i < partner.downlines.length - 1 ? '1px solid #eee' : 'none' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ fontWeight: 500 }}>{d.name}</div>
                    <div style={{ color: '#52c41a' }}>¥{formatMoney(d.total_commission)}</div>
                  </div>
                  <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>{d.phone} | {d.level}</div>
                </div>
              ))
            ) : (
              <div style={{ textAlign: 'center', padding: '40px 0', color: '#999' }}>
                <div style={{ fontSize: 32, marginBottom: 8 }}>📭</div>
                <div>暂无下线</div>
                <div style={{ fontSize: 12, marginTop: 4 }}>分享推广链接招募下线</div>
              </div>
            )}
          </div>
        )}
      </div>
      
      {/* 升级弹窗 */}
      {showUpgrade && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20 }}>
          <div style={{ background: '#fff', borderRadius: 16, padding: 24, maxWidth: 400, width: '100%' }}>
            <h2 style={{ fontSize: 18, margin: '0 0 16px', textAlign: 'center' }}>🌟 升级{UPGRADE_TYPES[upgradeType].name}</h2>
            <div style={{ background: '#fff7e6', borderRadius: 12, padding: 16, marginBottom: 16, border: `2px solid ${UPGRADE_TYPES[upgradeType].color}` }}>
              <div style={{ fontWeight: 600, color: UPGRADE_TYPES[upgradeType].color, marginBottom: 8 }}>{UPGRADE_TYPES[upgradeType].name}</div>
              <div style={{ fontSize: 13, color: '#666' }}>
                {UPGRADE_TYPES[upgradeType].features.map((f, i) => (
                  <div key={i}>• {f}</div>
                ))}
              </div>
            </div>
            <div style={{ display: 'flex', gap: 12 }}>
              <button onClick={() => setShowUpgrade(false)} style={{ flex: 1, padding: '12px', background: '#f0f0f0', color: '#666', border: 'none', borderRadius: 8, cursor: 'pointer' }}>取消</button>
              <button 
                onClick={async () => {
                  setUpgradeLoading(true)
                  try {
                    const res = await fetch(`${BOXIAOTU_API}/partners/upgrade`, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ partner_id: partner.id, new_level: upgradeType })
                    })
                    const data = await res.json()
                    if (data.success) {
                      alert('升级成功！')
                      setShowUpgrade(false)
                      window.location.reload()
                    } else {
                      alert(data.error || '升级失败')
                    }
                  } catch {
                    alert('网络错误')
                  }
                  setUpgradeLoading(false)
                }}
                disabled={upgradeLoading}
                style={{ flex: 1, padding: '12px', background: upgradeLoading ? '#ccc' : UPGRADE_TYPES[upgradeType].color, color: '#fff', border: 'none', borderRadius: 8, cursor: upgradeLoading ? 'not-allowed' : 'pointer' }}
              >
                {upgradeLoading ? '升级中...' : `立即升级 ¥${UPGRADE_TYPES[upgradeType].fee}`}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
